import { Mock, Photo } from '../components/Mock';
import { Notice, Section } from '../components/Section';
import { trackEvent } from '../lib/analytics';
import { usePageMeta } from '../lib/usePageMeta';
import { useSettings } from '../lib/useSettings';
import { SEO } from '../seo/pages';

/**
 * Shirts are sold on a separate lifestyle site and are deliberately not mentioned here.
 *
 * The copy below states only what the GoFundMe page itself says (organiser,
 * beneficiary, what the fund is for) and quotes it with attribution. The
 * earlier sample paragraph invented specifics (copays, Tampa, a sister, a
 * quote from the couple) and read as if Brandon were still in treatment; it
 * was removed on 2026-09-08. See docs/COPY.md.
 */
export function DonatePage() {
  usePageMeta(SEO.donate.title, SEO.donate.description, { jsonLd: SEO.donate.jsonLd });
  const { data: s } = useSettings();
  return (
    <Section eyebrow="Support the family" title="Donate">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-start">
        <div>
          <p className="text-2xl text-ink-50">Surrounding Brandon and Shawna with love and support.</p>
          <Mock className="mt-6">
            <p className="text-lg text-ink-200">
              Rooms cover the weekend. Anything more goes to Shawna through the family's
              GoFundMe, the one place to give. It was set up for the medical expenses, medications,
              living expenses, transportation and the many unexpected costs of Brandon&apos;s care,
              and the money goes to Shawna directly.
            </p>
            <p className="mt-4 text-lg text-ink-200">
              From the fund page: &ldquo;Our hope is to ease some of their
              financial burden so Brandon and Shawna can focus on what matters most &mdash; each
              other, their family, and making the most of the precious time they have
              together.&rdquo;
            </p>
          </Mock>
          <div className="mt-8 flex flex-wrap gap-3">
            {s?.donationUrl ? (
              <a
                href={s.donationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                onClick={() => trackEvent('donate_click')}
              >
                Donate to the family
              </a>
            ) : (
              <Notice tone="info">The donation link will be posted here soon.</Notice>
            )}
          </div>
          <p className="mt-4 text-sm text-ink-400">
            Donations go straight to the GoFundMe organiser; this site never touches them. Room
            payments are separate and pay the hotel block.
          </p>
        </div>
        <Photo name="donate.jpg" alt="Brandon and Shawna" className="aspect-[4/3] w-full" />
      </div>
    </Section>
  );
}
